import React, { useState } from 'react';
import { Input } from '../Common/Input';
import { Advice } from '../Common/Card';
import { FormLabelWInfo } from '../Common/Dialog';

const BasicInfoForm = ({ formData, setFormData, info, onInvalid, onInput }) => {
  const [nameTouched, setNameTouched] = useState(false);
  const [descriptionTouched, setDescriptionTouched] = useState(false);
  const nameError = nameTouched && !formData.name.trim();
  const descriptionError = descriptionTouched && !formData.description.trim();

  return (
  <div className="modal-content">
    <div className="modal-content__inner">
      <div className="modal-content__inner-block">
        <FormLabelWInfo htmlFor="name" text={info.name} error={nameError}>Name der Aktivität</FormLabelWInfo>
        <Input
          id="name"
          value={formData.name}
          onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
          onBlur={() => setNameTouched(true)}
          placeholder="z.B. Tierpark Goldau"
          required
          className={`${nameError ? 'input--error' : ''} text__input`}
          onInvalid={onInvalid}
          onInput={onInput}
        />
      </div>
      <div className="modal-content__inner">
        <FormLabelWInfo htmlFor="description" text={info.description} error={descriptionError}>Beschreibung</FormLabelWInfo>
        <textarea
          id="description"
          value={formData.description}
          onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
          onBlur={() => setDescriptionTouched(true)}
          placeholder="Beschreiben Sie die Aktivität..."
          className={`input${descriptionError ? ' input--error' : ''}`}
          rows="4"
          required
          onInvalid={onInvalid}
          onInput={onInput}
        />
      </div>
      <div className="modal-content__inner">
        <FormLabelWInfo htmlFor="website" text={info.website}>Webseite der Aktivität (optional)</FormLabelWInfo>
        <Input
          id="website"
          type="url"
          value={formData.website}
          onChange={(e) => setFormData(prev => ({ ...prev, website: e.target.value }))}
          placeholder="https://..."
          onInvalid={onInvalid}
          onInput={onInput}
          className="text__input"
        />
      </div>
    </div>
    <Advice text="Ein Link zur Webseite hilft Nutzern, mehr Details zur Veranstaltung zu sehen." />
  </div>
  );
};

export default BasicInfoForm;
